import { BaseLayout } from "./BaseLayout";

export default BaseLayout;
